
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tWhse/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tWhse/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tWhse/findPage',
        method: 'post',
      data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tWhse.js